import { ReactNode } from 'react';

export interface FAQItem {
  key: string;
  label: string;
  children: ReactNode;
}
const text = `
  There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. 
`;
export const faqMapping: { [key: string]: FAQItem[] } = {
  home: [
    {
      key: '1',
      label: 'Is Odin Mortgage licensed to provide credit advice?',
      children: <p>{text}</p>,
    },
    {
      key: '2',
      label: 'Where can I start the process with Odin Mortgage?',
      children: <p>{text}</p>,
    },
    {
      key: '3',
      label: 'Why should I use Odin Mortgage?',
      children: <p>{text}</p>,
    },
    {
      key: '4',
      label: 'Is Odin Mortgage licensed to provide credit advice?',
      children: <p>{text}</p>,
    },
  ],
  mortgage: [
    {
      key: '1',
      label: 'Is Odin Mortgage licensed to provide credit advice?',
      children: <p>{text}</p>,
    },
    {
      key: '2',
      label: 'Where can I start the process with Odin Mortgage?',
      children: <p>{text}</p>,
    },
    {
      key: '3',
      label: 'Why should I use Odin Mortgage?',
      children: <p>{text}</p>,
    },
    {
      key: '4',
      label: 'Is Odin Mortgage licensed to provide credit advice?',
      children: <p>{text}</p>,
    },
  ],
};
